module.exports = __webpack_public_path__ + "static/media/veh.electrico.bc6bfb4c.png";